import { render } from "./ProjectPreview.vue?vue&type=template&id=3ae7a16f"
import script from "./ProjectPreview.vue?vue&type=script&lang=js"
export * from "./ProjectPreview.vue?vue&type=script&lang=js"

import "./ProjectPreview.vue?vue&type=style&index=0&id=3ae7a16f&lang=css"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__